import React, { useState , useCallback} from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqData = [
    {
      question: 'How do I become an instructor?',
      answer: 'To become an instructor, you need to sign up, create a profile, and submit a demo video showcasing your teaching style. Once approved, you can start creating and uploading your courses.',
    },
    {
      question: 'What are the technical requirements for uploading courses?',
      answer: 'You should have a camera (smartphone or DSLR) with at least 1080p resolution, a good microphone, and a quiet, well-lit environment. You can also use screen recording software for software-related courses.',
    },
    {
      question: 'How long does it take to get my course approved?',
      answer: 'Our team will review your course within 48-72 hours. Once approved, it will be published and available to students.',
    },
    {
      question: 'What kind of content should I include in my course?',
      answer: 'Your course should be structured into modules or lessons with clear objectives. You can include videos, quizzes, assignments, and additional resources (e.g., PDFs, templates) to enhance the learning experience.',
    },
    {
      question: 'How do I price my course?',
      answer: 'You can choose to price your course based on market trends, the length and depth of the content, and your teaching expertise. We recommend researching similar courses to find a competitive price range.',
    },
    {
      question: 'How can I market my course?',
      answer: 'You can promote your course via social media, blogs, email newsletters, and even paid advertising. Engage with potential learners by sharing your knowledge, student testimonials, and offering discounts or limited-time promotions.',
    },
    {
      question: 'How do I get paid?',
      answer: 'You will be paid via direct bank deposit, based on your earnings from course sales. Payments are made on a monthly basis after reaching the payment threshold.',
    },
  ];

  const goToNext = useCallback(() => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % faqData.length);
  },[faqData.length]);

  const goToPrevious = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + faqData.length) % faqData.length);
  };
 

  return (
    <div className="faq-section">
      <h2>Frequently Asked Questions (FAQ)</h2>
      <div className="faq-carousel">
        <div className="faq-item">
          <div className="faq-question">
            <span>{faqData[activeIndex].question}</span>
          </div>
          <div className="faq-answer">
            <p>{faqData[activeIndex].answer}</p>
          </div>
        </div>
        <div className="carousel-controls">
          <button className="prev-btn" onClick={goToPrevious}>
            <i className="fa fa-arrow-left"></i>
          </button>
          <button className="next-btn" onClick={goToNext}>
            <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
